export default {
    name: 'examens-physiques',
    components: {},
    props: [],
    data() {
        return {
            examens_physiques: {
                consultation_id: 0,
                abdomen: '',
                mamelon: '',
                ht_uterine: '',
                saignements: '',
                perte_eaux: '',
                sein_droit: {
                    libelle: '',
                    id: ''
                },
                promontoire_accessible: '',
                paleur_conjonctive: '',
                sein_gauche: {
                    libelle: '',
                    id: ''
                },
                etat_col: '',
                position_col: '',
                longueur_col: '',
                ouverture_col: '',
                odeur_pertes: '',
                couleur_pertes: '',
                annexe: ''

            },
        }
    },
    computed: {
        examens() {
            return this.$store.getters['cpn_examens_physiques_courante'];
        },
    },
    watch: {
        examens() {
            let data = this.examens;

            if (Object.entries(data).length > 0) {
                // this.examens_physiques = {
                //     consultation_id: this.consultation,
                //     abdomen: data.abdomen,
                //     mamelon: (data.mamelons_anormaux || data.mamelons_anormaux == 1) ? { id: 1, libelle: 'Oui' } : { id: 2, libelle: 'Non' },
                //     ht_uterine: (data.etat_hauteur_uterine || data.etat_hauteur_uterine == 1) ? { id: 1, libelle: 'Normale' } : { id: 2, libelle: 'Anormale' },
                //     saignements: (data.saignements || data.saignements == 1) ? { id: 1, libelle: 'Oui' } : { id: 2, libelle: 'Non' },
                //     perte_eaux: (data.perte_eau || data.perte_eau == 1) ? { id: 1, libelle: 'Oui' } : { id: 2, libelle: 'Non' },
                //     sein_droit: data.etat_sein_droit,
                //     promontoire_accessible: (data.promontoire_accessible || data.promontoire_accessible == 1) ? { id: 1, libelle: 'Oui' } : { id: 2, libelle: 'Non' },
                //     paleur_conjonctive: (data.conjonctives_pales || data.conjonctives_pales == 1) ? { id: 1, libelle: 'Oui' } : { id: 2, libelle: 'Non' },
                //     sein_gauche: data.etat_sein_gauche,
                //     etat_col: data.etat_col,
                //     position_col: data.position_col,
                //     longueur_col: data.longueur_col,
                //     ouverture_col: data.ouverture_col,
                //     odeur_pertes: data.odeur_perte,
                //     couleur_pertes: data.couleur_perte,
                //     annexe: data.annexe_col
                // }
                let mamelon_id = 0
                if (data.mamelons_anormaux != '') {
                    mamelon_id = (data.mamelons_anormaux == 'Oui')?1:2;
                }
                let mamelon = {
                    id: mamelon_id,
                    libelle: data.mamelons_anormaux
                }

                let h_uterine_id = 0
                if (data.etat_hauteur_uterin != '') {
                    h_uterine_id = parseInt(data.etat_hauteur_uterine);
                }
                let h_uterine = {
                    id: h_uterine_id,
                    libelle: (h_uterine_id == 1)?'Normale':'Anormale'
                }

                let saignement_id = 0
                if (data.saignements != '') {
                    saignement_id = parseInt(data.saignements);
                }
                let saignement = {
                    id: saignement_id,
                    libelle: (saignement_id == 1)?'Oui':'Non'
                }

                let perte_id = 0
                if (data.perte_eau != '') {
                    perte_id = parseInt(data.perte_eau);
                }
                let perte = {
                    id: perte_id,
                    libelle: (perte_id == 1)?'Oui':'Non'
                }

                let promontoire_id = 0
                if (data.promontoire_accessible != '') {
                    promontoire_id = parseInt(data.promontoire_accessible);
                }
                let promontoire = {
                    id: promontoire_id,
                    libelle: (promontoire_id == 1)?'Oui':'Non'
                }

                let conjonctives_id = 0
                if (data.conjonctives_pales != '') {
                    conjonctives_id = parseInt(data.conjonctives_pales);
                }
                let conjonctives = {
                    id: conjonctives_id,
                    libelle: (conjonctives_id == 1)?'Oui':'Non'
                }
                
                

                this.examens_physiques = {
                    consultation_id: this.consultation,
                    abdomen: data.abdomen,
                    mamelon: (data.mamelons_anormaux != '')?mamelon:'',
                    ht_uterine: (data.etat_hauteur_uterine != '')?h_uterine:'',
                    saignements: (data.saignements != '')?saignement:'',
                    perte_eaux: (data.perte_eau != '')?perte:'',
                    sein_droit: data.etat_sein_droit,
                    promontoire_accessible: (data.promontoire_accessible != '')?promontoire:'',
                    paleur_conjonctive: (data.conjonctives_pales != '')?conjonctives:'',
                    sein_gauche: data.etat_sein_gauche,
                    etat_col: data.etat_col,
                    position_col: data.position_col,
                    longueur_col: data.longueur_col,
                    ouverture_col: data.ouverture_col,
                    odeur_pertes: data.odeur_perte,
                    couleur_pertes: data.couleur_perte,
                    annexe: data.annexe_col
                }
            }

        }
    },
    mounted() {
        
    },
    methods: {
        
    }
}